<div
  [ngClass]="{ 'fgbcl-predictor': groupType == groupTypes.Predictor, 'fgbcl-trivia': groupType == groupTypes.Trivia }"
  class="modal-body"
>
  <div class="fgbcl-games-modal-header container d-none d-lg-flex">
    <div class="fgbcl-games-modal-back-button" (click)="closeModel()">
      <span class="material-symbols-outlined material-icons me-1"> arrow_back_ios_new </span>
    </div>
    <div class="fgbcl-games-modal-sponsor-section" *ngIf="gameDetails?.Sponsor && gameDetails.Sponsor.SponsorId">
      <div class="fgbcl-games-modal-sponsor-presented-by-text">
        {{ 'fgbcl.game.modal.sponsor.presented.by.text' | translate }}:
      </div>
      <a [attr.href]="gameDetails?.Sponsor?.SponsorLink || null" [attr.target]="gameDetails?.Sponsor?.SponsorLink ? '_blank' : null">
        <img
          class="fgbcl-games-modal-sponsor-image"
          src="{{ gameDetails?.Sponsor?.SponsorImage | contentImage: '1' }}"
          alt="{{ gameDetails?.Sponsor?.SponsorText }}"
        />
      </a>
    </div>
  </div>
  <div class="fgbcl-mobile-games-modal-header container d-lg-none">
    <div class="fgbcl-mobile-games-modal-back-button d-flex" (click)="closeModel()">
      <span class="material-symbols-outlined material-icons me-1"> arrow_back_ios_new </span>
    </div>
    <h3 *ngIf="groupType == groupTypes.Predictor">{{ 'games.page.predictor.title' | translate }}</h3>
    <h3 *ngIf="groupType == groupTypes.Trivia">{{ 'games.page.trivia.title' | translate }}</h3>
  </div>
  <div
    class="fgbcl-games-modal-container container"
    [ngClass]="{
      'game-predictor-model-background': groupType == groupTypes.Predictor,
      'game-trivia-model-background': groupType == groupTypes.Trivia,
    }"
  >
    <ng-container *ngIf="gameDetails && gameDetails.Questions.length > 0">
      <ng-container *ngIf="groupType == groupTypes.Trivia">
        <fgbcl-game-trivia-question-list
          [gameDetails]="gameDetails"
          [groupId]="gameGroup.GroupId"
          (closeModal)="closeModel()"
        ></fgbcl-game-trivia-question-list>
      </ng-container>

      <ng-container *ngIf="groupType == groupTypes.Predictor">
        <div>
          <fgbcl-game-predictor-question-list
            [predictorStatus]="predictorStatus"
            [predictor]="gameDetails"
            [groupId]="gameGroup.GroupId"
            [endDate]="gameGroup.EndDate"
            (closeModal)="closeModel()"
            (unsavedChangesEvent)="updateUnsavedChanges($event)"
          ></fgbcl-game-predictor-question-list>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<!-- Modal template for confirmation -->
<ng-template #content let-modal>
  <fgbcl-game-predictor-unsaved-warning-modal (confirm)="modal.close('confirm')" (cancel)="modal.dismiss()">
  </fgbcl-game-predictor-unsaved-warning-modal>
</ng-template>
